import {
  LoginAuthWithCredentialsParams,
  LoginAuthWithCredentialsResponse,
  LoginOAuth,
  LoginOAuthParams,
  LoginOAuthResponse
} from '../models';
import { LoginAuthUrl } from '../models/util.interface';
import { mfaAuthConfig } from './multi-factor-authentication.mocks';
import { idpConfig } from './oauth-config.mocks';

export const pkcCodeMock = {
  codeChallenge: '1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4',
  codeVerifier: 'c432d404eaae765962a7682e4321173d2232199c685caf3e55dce7f1'
};

export const fakePkcMock = {
  codeChallenge: ' ',
  codeVerifier: ' '
};

export const loginOAuthParamsMocks: LoginOAuthParams = {
  oauthConfig: mfaAuthConfig,
  pkceCode: pkcCodeMock
};

export const returnMockPromise: LoginOAuth = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'USERNAME_PASSWORD_REQUIRED',
  showRememberMyUsername: false,
  showThisIsMyDevice: true,
  thisIsMyDeviceSelected: true,
  showCaptcha: false,
  rememberMyUsernameSelected: false
};

export const resourceNotFoundMockLoginAuth: LoginOAuth = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'RESOURCE_NOT_FOUND',
  showRememberMyUsername: false,
  showThisIsMyDevice: true,
  thisIsMyDeviceSelected: true,
  showCaptcha: false,
  rememberMyUsernameSelected: false
};

export const loginAuthWithCredentailsMock = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'RESOURCE_NOT_FOUND',
  showRememberMyUsername: false,
  showThisIsMyDevice: true,
  thisIsMyDeviceSelected: true,
  showCaptcha: false
};

export const loginAuthWithCredentailsEmptyIDMock = {
  id: '',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'RESOURCE_NOT_FOUND',
  showRememberMyUsername: false,
  showThisIsMyDevice: true,
  thisIsMyDeviceSelected: true,
  showCaptcha: false
};

export const resourceNotFoundMock = {
  code: 'RESOURCE_NOT_FOUND',
  message: 'The requested resource was not found.'
};

export const authMock = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  showRememberMyUsername: false,
  thisIsMyDeviceSelected: true,
  rememberMyUsernameSelected: false
};

export const authorizationCompletedMock: LoginOAuth = {
  id: 'DNC7CNpFJv',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'COMPLETED',
  authorizeResponse: { code: '2wlvVyUxgY-UsSapgZBQ5DTI2eQF-eYo214AAAAo' }
};

export const authorizationCompletedResponseMock: LoginOAuthResponse = {
  id: 'DNC7CNpFJv',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'COMPLETED',
  authorizeResponse: { code: '2wlvVyUxgY-UsSapgZBQ5DTI2eQF-eYo214AAAAo' }
};

export const loginAuthMock = {
  id: 'sdsdsd',

  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',

  rememberMyUsernameSelected: false
};
export const mockPingServiceUrl = {
  loginOAuthUrl:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4',
  mfaLoginOAuthUrl:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&mfaAction=existingusersetup&v=1',
  newUserMfaLoginOAuthUrlWithoutEmailValidation:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&v=1',
  newUserMfaLoginOAuthUrlEmailValidation:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&verifyemailmfa=yes',
  selfServiceResetLoginOAuthUrl:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&mfaAction=sspr&v=1',
  loginOAuthUrlPersistant:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&prompt=login',
  loginAuthWithCredentialsUrl:
    'https://signin-si.delta.com/pf-ws/authn/flows/zisuu',
  swapAuthForAccessTokensUrl: 'https://signin-si.delta.com/as/token.oauth2',
  body: 'grant_type=authorization_code&code=zisuu&code_verifier=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&client_id=deltacom',
  introspectionUrl: 'https://signin-si.delta.com/as/introspect.oauth2',
  loginOAuthRedirectfulUrl:
    'https://signin-si.delta.com/pf-ws/authn/flows/zisuu',
  loginOAuthUrlPersistantRememberMe:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&v=1&prompt=login',
  loginOAuthUrlRememberMe:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&v=1'
};

export const inputMock = {
  userName: '8002414699',
  password: 'Delta999',
  rememberMe: 'N',
  persistentLogin: 'N',
  refreshURL: '/',
  tokenId: '91ccc312-6442-4acb-9b75-3a8f8d77159d',
  formNameSubmitted: 'login'
};

export const errorOCodeMock: LoginOAuth = {
  error: {},
  errors: [{ code: 'invalid_access' }],
  status: '504'
};

export const errorErrorStringMock: LoginOAuth = {
  error: { error: 'invalid_access' }
};

export const errorDescriptionLoginOAuthMock: LoginOAuth = {
  error_description: 'invalid_request'
};

export const userMessageErrorDetailsMock: LoginOAuth = {
  error: {
    details: [{ userMessage: '' }]
  }
};

export const loginAuthWithCredentialsResponse: LoginAuthWithCredentialsResponse =
  {
    id: 'zisuu',
    pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
    status: 'RESUME',
    showRememberMyUsername: false,
    showThisIsMyDevice: true,
    resumeUrl: 'https://signin-si.delta.com/as/token.oauth2',
    thisIsMyDeviceSelected: true,
    showCaptcha: false
  };

export const loginWithCredentialsResponse: LoginAuthWithCredentialsResponse = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'RESUME',
  showRememberMyUsername: false,
  showThisIsMyDevice: true,
  thisIsMyDeviceSelected: true,
  showCaptcha: false
};

export const loginAuthWithCredentailsMockResponse = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'COMPLETED',
  authorizeResponse: {
    code: 'D0_nLf6F6DCvSM7IPUOjf8BEeqEnfq5pogsAAAAo'
  },
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/zisuu'
    }
  }
};

export const loginAuthShouldRememberMockResponse = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'SHOULD_REMEMBER_USER',
  authorizeResponse: {
    code: 'D0_nLf6F6DCvSM7IPUOjf8BEeqEnfq5pogsAAAAo'
  },
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/zisuu'
    }
  }
};

export const loginAuthCompletedMockResponse = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'COMPLETED',
  authorizeResponse: {
    code: 'D0_nLf6F6DCvSM7IPUOjf8BEeqEnfq5pogsAAAAo'
  },
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/zisuu'
    }
  }
};

export const loginAuthRememberedDeviceMockResponse = {
  id: 'zisuu',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'REMEMBERED_DEVICE_DETAILS',
  encryptedToken: 'adfadfadfadadff',
  fingerprint: 'adadadf',
  authorizeResponse: {
    code: 'D0_nLf6F6DCvSM7IPUOjf8BEeqEnfq5pogsAAAAo'
  },
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/zisuu'
    }
  }
};

export const loginFingerPrintMockResponse = {
  encryptedToken: '',
  fingerprint: ''
};

export const accessDeniedMock = {
  details: [
    {
      code: 'access_denied',
      message: 'Credential validation failed.',
      userMessage:
        "PF_CREDENTIAL_VALIDATION_FAILED|We're sorry, but we were unable to locate your account with the information provided. Please confirm your credentials and try again."
    }
  ],
  message: 'One or mmore validation errors occured',
  userMessage: 'One or more validation errors occurred.'
};

export const credentialVaidationErrorMock = {
  code: 'VALIDATION_ERROR',
  message: 'One or more validation errors occurred.',
  userMessage: 'One or more validation errors occurred.',
  details: [
    {
      code: 'CREDENTIAL_VALIDATION_FAILED',
      message: 'Credential validation failed.',
      userMessage:
        "PF_CREDENTIAL_VALIDATION_FAILED|We're sorry, but we were unable to locate your account with the information provided. Please confirm your credentials and try again."
    }
  ]
};

export const authorizationErrorMock = {
  error: {},
  headers: {},
  message:
    'Http failure response for' +
    mockPingServiceUrl.loginOAuthUrl +
    '504 Gateway Timeout',
  name: 'HttpErrorResponse',
  code: 'access_denied',
  ok: false,
  status: 504,
  statusText: 'Gateway Timeout',
  url: ''
};

export const loginAuthCredErrorResponseMock = {
  error: {
    error: {}
  },
  headers: {},
  message:
    'Http failure response for' +
    mockPingServiceUrl.loginAuthWithCredentialsUrl +
    '504 Gateway Timeout',
  name: 'HttpErrorResponse',
  ok: false,
  status: 504,
  statusText: 'Gateway Timeout',
  url: ''
};

export const swapAccessTokenResponseErrorMock = {
  error: {
    error: {}
  },
  headers: {},
  message:
    'Http failure response for' +
    mockPingServiceUrl.swapAuthForAccessTokensUrl +
    '504 Gateway Timeout',
  name: 'HttpErrorResponse',
  ok: false,
  status: 504,
  statusText: 'Gateway Timeout',
  url: ''
};

export const fakeInputMock = {
  rememberMe: '',
  persistentLogin: '',
  refreshURL: '',
  tokenId: '91ccc312-6442-4acb-9b75-3a8f8d77159d',
  formNameSubmitted: 'login'
};

export const fakeUserCred = {
  userName: '',
  password: '',
  rememberMe: '',
  persistentLogin: ''
};

export const loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams = {
  flowId: 'k22wI',
  oauthConfig: idpConfig
};

export const requestPayload = {
  username: '8002414699',
  password: 'Delta999'
};

export const swapAuthForAccessTokensResponseMock = {
  access_token:
    'eyJhbGciOiJSUzI1NiIsImtpZCI6InBabnJOaGdaTFN1MWZNOVVVSkRWc19jcHNzMCIsInBpLmF0bSI6Im9jZ3IifQ.eyJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIGdpdmVuX25hbWUgbWlkZGxlX25hbWUgZmFtaWx5X25hbWUgcHJlZmVycmVkX3VzZXJuYW1lIiwiY2xpZW50X2lkIjoiZGVsdGFjb20iLCJzdWIiOiIxMDAwMDAwMDA5OSIsImxldmVsX29mX3RydXN0IjoiMCIsImV4cCI6MTY0NDM1MTQyNX0.XSfF5HMKFb4OqwcOY8yZq4lX5i-vRRdY-M1-mjpMkyqRZG7hpBIByS8m4lbVqb6D_raURTxLMwYd7TFDPWKOyJmmoCzkZENQQevIBvURgflRdDk-QNcpjMQYa3HsF7zL9_jnBkWmXOPz0fs46tRg-hXS1iYuJyAR8OmPOa6rjjyZoR-FEs2enNbNVBRNAkb1qxZyZNAcL9Fn1DDObosHKjqX_I47SsVM7Q68vV51MunpjGQ0muV37DQVv0lHmjIbQpNP0NwYmiTzp6kplmp_xT_FP1uzgwl-wTt9OOP5KMoxsyZohLABpBPPQLmhIw1AII3g9iK89IvsBf3kfkMSmg',
  id_token:
    'eyJhbGciOiJSUzI1NiIsImtpZCI6InBabnJOaGdaTFN1MWZNOVVVSkRWc19jcHNzMCJ9.eyJzdWIiOiIxMDAwMDAwMDA5OSIsImF1ZCI6ImRlbHRhY29tIiwianRpIjoiRGVkdUluTU5SNVpOYUh5MkRwMEFiZSIsImlzcyI6Imh0dHBzOi8vc2lnbmluLXNpLmRlbHRhLmNvbSIsImlhdCI6MTY0NDM0OTU4MCwiZXhwIjoxNjQ0MzQ5ODgwLCJhdXRoX3RpbWUiOjE2NDQzNDk1ODAsImVtYWlsIjoiWm9yYW5hU2VhdHRsZUBleGFtcGxlLm9yZyIsInBpLnNyaSI6IkNMTmdrU2VpQ2FYbnFyRDdGcHplSzc0UGRWYy4uQXNpTS5laXRic2NOamFqNlJFS1k4TnFjWkRzeFI4In0.m42sRFy5NS_HLFksoVAmpPfFU9R8UNMUlec4_Ps6f20o9GOp0ihulOPu3Xvagwo0eKT0xq5ZCi2qf_kygcqtoHl3sCDsIdK4Z52tNGG5f2jCEJ3i1sPGO7ocBg0AOBozTswlsSEQ6HmIRYGybRdAbbK9ep7PDYkSY9OIVShtJlY22TBS8njqmOsBNhspN1FzaQLWq5eQvOcOptgUIPCN5RA4nUX5Eg9BBwDELYhBvzo4ELQ9K07BAwShFb5GqLcXQzQy48Wxu2_by0-Y3iqvxj6yZBUNLRLzfktonUCwF0lWEkv3DXv8z2O-zk4SHB4cm4e7q5WykRyZU70XBQmgxA',
  token_type: 'Bearer',
  expires_in: 1799
};

export const swapAuthForAccessTokenResponseMockWithMdc = {
  access_token:
    'eyJhbGciOiJSUzI1NiIsImtpZCI6IlBiMk0yRVlCMzJuSXFKam9oRWJnYUdzRzd4Y19SUzI1NiIsInBpLmF0bSI6Im9jZ3IifQ.eyJzY29wZSI6Im9wZW5pZCIsImF1dGhvcml6YXRpb25fZGV0YWlscyI6W10sImNsaWVudF9pZCI6ImRlbHRhY29tIiwiaXNzIjoiaHR0cHM6Ly9zaWduaW4tc2kuZGVsdGEuY29tIiwianRpIjoidUR5WjBSSld5YnF3MGJNWG1rNzhlYUsxN3VGU0lON2UiLCJhdWQiOiJkZWx0YWNvbSIsInN1YiI6IjgwMTU2OTQxMzkiLCJsZXZlbF9vZl90cnVzdCI6IjEiLCJtaWQiOiJmZDFjZDJjYy1jMjBkLTQ2Y2YtODFjZS1mNzY0YjVkNzgwMzMiLCJpYXQiOjE3MTk1MzEyOTYsIm1kYyI6IjMiLCJleHAiOjE3MTk1MzMwOTZ9.VoOvcE3g3Y90nKGIUTKaFnDvRW-yVau-bNh8BRWbxDxehcRjXTTT6MACu2ohlhIfVPPPT65rjbqLQZkbbHkcXTrk_2F6cvqvPF2EfKJpz-XzDdInJHBLvlojgF6K-wAoTL3TWTVLd71y3r1qaXYjh8lueTbaR9VJLlXDiSzPPZ4druYhWfiuIQO2XAFVXOZti3WKveur97dppXWm8AIFA6KFwbYRtj2N2jzlzcUkZbbFIlloBcMquIuI1rsf4B9qnCVB7YmphxcVnEyCXIW-hPc4_UWXktV72jHlmIuvq4-J0B46K5i_8xBUJwonh2uPYwnomZu0EAAnchtZ_OL8Dg'
};

export const swapAuthForAccessTokensFailedResponseMock = {
  id_token:
    'eyJhbGciOiJSUzI1NiIsImtpZCI6InBabnJOaGdaTFN1MWZNOVVVSkRWc19jcHNzMCJ9.eyJzdWIiOiIxMDAwMDAwMDA5OSIsImF1ZCI6ImRlbHRhY29tIiwianRpIjoiRGVkdUluTU5SNVpOYUh5MkRwMEFiZSIsImlzcyI6Imh0dHBzOi8vc2lnbmluLXNpLmRlbHRhLmNvbSIsImlhdCI6MTY0NDM0OTU4MCwiZXhwIjoxNjQ0MzQ5ODgwLCJhdXRoX3RpbWUiOjE2NDQzNDk1ODAsImVtYWlsIjoiWm9yYW5hU2VhdHRsZUBleGFtcGxlLm9yZyIsInBpLnNyaSI6IkNMTmdrU2VpQ2FYbnFyRDdGcHplSzc0UGRWYy4uQXNpTS5laXRic2NOamFqNlJFS1k4TnFjWkRzeFI4In0.m42sRFy5NS_HLFksoVAmpPfFU9R8UNMUlec4_Ps6f20o9GOp0ihulOPu3Xvagwo0eKT0xq5ZCi2qf_kygcqtoHl3sCDsIdK4Z52tNGG5f2jCEJ3i1sPGO7ocBg0AOBozTswlsSEQ6HmIRYGybRdAbbK9ep7PDYkSY9OIVShtJlY22TBS8njqmOsBNhspN1FzaQLWq5eQvOcOptgUIPCN5RA4nUX5Eg9BBwDELYhBvzo4ELQ9K07BAwShFb5GqLcXQzQy48Wxu2_by0-Y3iqvxj6yZBUNLRLzfktonUCwF0lWEkv3DXv8z2O-zk4SHB4cm4e7q5WykRyZU70XBQmgxA',
  token_type: 'Bearer'
};

export const mockAllPingServiceUrl: LoginAuthUrl = {
  body: 'grant_type=authorization_code&code=undefined&code_verifier=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&client_id=deltacom',
  introspectionUrl: 'https://signin-si.delta.com/as/introspect.oauth2',
  loginAuthWithCredentialsUrl:
    'https://signin-si.delta.com/pf-ws/authn/flows/undefined',
  loginOAuthRedirectfulUrl:
    'https://signin-si.delta.com/pf-ws/authn/flows/undefined',
  loginOAuthUrl:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4',
  loginOAuthUrlPersistant:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&prompt=login',
  loginOAuthUrlPersistantRememberMe:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=openid profile email given_name middle_name family_name preferred_username&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&=&prompt=login',
  loginOAuthUrlRememberMe:
    'https://signin-si.delta.com/as/authorization.oauth2?client_id=deltacom&response_type=code&scope=&response_mode=pi.flow&code_challenge_method=S256&code_challenge=1c1YGlyHpPXDfPRHHbTivo4_6fkdDizLmQsKi787oO4&=',
  swapAuthForAccessTokensUrl: 'https://signin-si.delta.com/as/token.oauth2'
};

export const InvalidGrantResponseMock: LoginOAuthResponse = {
  error_description: 'The code_verifier sent does meet the the criteria',
  error: 'invalid_grant'
};

export const InvalidResponseMock: LoginOAuthResponse = {
  error_description: 'The code_verifier sent does meet the the criteria',
  error: {
    error: 'invalid_grant'
  }
};

export const InvalidErrorMock: LoginOAuthResponse = {
  error_description: 'The code_verifier sent does meet the the criteria',
  error: {
    error: 'invalid_grant',
    code: 'CREDENTIAL_VALIDATION_FAILED'
  },
  code: 'CREDENTIAL_VALIDATION_FAILED'
};

export const loginRememberMeErrorDetailsResponse: LoginOAuth = {
  error: {
    details: [
      {
        userMessage:
          "PF_CREDENTIAL_VALIDATION_FAILED|We're sorry, but we were unable to locate your account with the informjation provided. Please confirm your credentials and try again",
        code: 'CREDENTIAL_VALIDATION_FAILED'
      }
    ]
  }
};
